import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { deepOrange, teal } from "@material-ui/core/colors";
import "./App.css";
import Forgot from "screens/public/Forgot";
import { CssBaseline } from "@material-ui/core";
import ErrorHandler from "./ErrorHandler";
import { StylesProvider } from "@material-ui/styles";
import Reset from "screens/public/Reset";
import StoreProvider from "lib/store/StoreProvider";
import AuthGate from "screens/AuthGate";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const theme = createMuiTheme({
  palette: {
    primary: teal,
    secondary: deepOrange,
    background: {
      default: "#eceff1",
      paper: "#fff",
    },
  },
  overrides: {
    MuiTypography: {
      h2: {
        fontSize: 30,
      },
    },
  },
});

const App: React.FunctionComponent<{}> = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <StylesProvider>
        <StoreProvider>
          <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <ErrorHandler>
              <div className="App">
                <Router>
                  <Switch>
                    <Route exact path="/passwordLost">
                      <Forgot />
                    </Route>
                    <Route exact path="/resetPassword">
                      <Reset />
                    </Route>
                    <Route>
                      <AuthGate />
                    </Route>
                  </Switch>
                </Router>
              </div>
            </ErrorHandler>
          </MuiThemeProvider>
        </StoreProvider>
      </StylesProvider>
    </QueryClientProvider>
  );
};

export default App;
